var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "16px",
    viewBox: "0 0 15 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5825,10.05 L9.5825,10.72 C9.5825,11.08984 9.28234,11.39 8.9125,11.39 L6.2325,11.39 C5.86266,11.39 5.5625,11.08984 5.5625,10.72 L5.5625,10.05 L2.2125,10.05 L2.2125,13.73768 C2.2125,13.91992 2.36325,14.07 2.55018,14.07 L12.59482,14.07 C12.78242,14.07 12.9325,13.92059 12.9325,13.73768 L12.9325,10.05 L9.5825,10.05 Z M9.5825,8.71 L13.26549,8.71 C13.45175,8.71 13.6025,8.55925 13.6025,8.37165 L13.6025,5.02835 C13.6025,4.83941 13.45309,4.69 13.26549,4.69 L1.87951,4.69 C1.69258,4.69 1.5425,4.84075 1.5425,5.02835 L1.5425,8.37165 C1.5425,8.56059 1.69191,8.71 1.87951,8.71 L5.5625,8.71 L5.5625,8.04 C5.5625,7.67016 5.86266,7.37 6.2325,7.37 L8.9125,7.37 C9.28234,7.37 9.5825,7.67016 9.5825,8.04 L9.5825,8.71 Z M3.5525,3.35 L3.5525,2.34567 C3.5525,1.42107 4.30156,0.67 5.22549,0.67 L9.91951,0.67 C10.84411,0.67 11.5925,1.41906 11.5925,2.34567 L11.5925,3.35 L13.26549,3.35 C14.19277,3.35 14.9425,4.09906 14.9425,5.02835 L14.9425,8.37165 C14.9425,8.92105 14.67986,9.40814 14.2725,9.71433 L14.2725,13.73768 C14.2725,14.66228 13.52076,15.41 12.59482,15.41 L2.55018,15.41 C1.62424,15.41 0.8725,14.66161 0.8725,13.73768 L0.8725,9.715 C0.46514,9.40948 0.2025,8.92239 0.2025,8.37165 L0.2025,5.02835 C0.2025,4.10107 0.95223,3.35 1.87951,3.35 L3.5525,3.35 Z M10.2525,2.34567 C10.2525,2.15874 10.10376,2.01 9.91951,2.01 L5.22549,2.01 C5.04258,2.01 4.8925,2.16008 4.8925,2.34567 L4.8925,3.35 L10.2525,3.35 L10.2525,2.34567 Z M6.9025,10.05 L8.2425,10.05 L8.2425,8.71 L6.9025,8.71 L6.9025,10.05 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "04-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.2-\\u2014-Profile",
    transform: "translate(-673.000000, -716.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Company-Title",
    transform: "translate(673.000000, 712.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16x16/Brief",
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#3A464F",
    xlinkHref: "#path-1"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon);
export default __webpack_public_path__ + "static/media/Company_Icon.a22f00731f80f59bb1b9a45fd944e789.svg";
export { ForwardRef as ReactComponent };